import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`If you're experiencing issues while using a version of node which is unsupported or unstable (odd numbered versions e.g. 0.7.x, 0.9.x, 0.11.x), it's very possible your issue will be fixed by simply using the `}<a parentName="p" {...{
        "href": "https://github.com/nodejs/LTS"
      }}>{`LTS`}</a>{` version of node.`}</p>
    <h2>{`See what version of node you're running:`}</h2>
    <pre><code parentName="pre" {...{}}>{`node -v
`}</code></pre>
    <h3>{`Updating node on Linux`}</h3>
    <p>{`For some Linux distributions (Debian/Ubuntu and RedHat/CentOS), the latest node version provided by the distribution may lag behind the stable version.  Here are `}<a parentName="p" {...{
        "href": "https://github.com/nodesource/distributions"
      }}>{`instructions from NodeSource`}</a>{` on getting the latest node.`}</p>
    <h3>{`Updating node on Windows`}</h3>
    <p>{`Install the latest msi from `}<a parentName="p" {...{
        "href": "https://nodejs.org/en/download"
      }}>{`https://nodejs.org/en/download`}</a></p>
    <h3>{`Updating node on OSX`}</h3>
    <p>{`Install the latest package from `}<a parentName="p" {...{
        "href": "https://nodejs.org/en/download"
      }}>{`https://nodejs.org/en/download`}</a></p>
    <p>{`or if you are using `}<a parentName="p" {...{
        "href": "http://brew.sh/"
      }}>{`homebrew`}</a></p>
    <pre><code parentName="pre" {...{}}>{`brew install node
`}</code></pre>
    <h3>{`An easy way to stay up-to-date`}</h3>
    <p>{`Node.js has lots of versions, and its development is very active. As a good practice to manage the various versions, we recommend that you use a version manager for your Node.js installation. There are many great options, here are a few:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/creationix/nvm"
        }}>{`NVM`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/marcelklehr/nodist"
        }}>{`nodist`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/tj/n"
        }}>{`n`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/isaacs/nave"
        }}>{`nave`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/hokaccha/nodebrew"
        }}>{`nodebrew`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      